import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageBanner from '../components/PageBanner';
import { SITE_CONTENT } from '../content';
import InstagramSection from '../components/InstagramSection';
import ReservationSection from '../components/ReservationSection';
import ExperienceSection from '../components/ExperienceSection';
import StatsSection from '../components/StatsSection';
import OurTeam from '../components/OurTeam';
import VisitSection from '../components/VisitSection';
import FeaturesSection from '../components/FeaturesSection';
import ImageCarosel from '../components/ImageCarosel';
import AboutUsIntro from '../components/AboutUsIntro';
import FloatingCta from '../components/FloatingCta';

const AboutUsPage = () => {
  const pageBanner = SITE_CONTENT.pages?.aboutUsPage?.pageBanner || {
    bgImage: "",
    eyebrow: "A Legacy of Flavours",
    title: "About Nawabi Caterers",
    breadcrumbs: [
      { label: "Home", to: "/" },
      { label: "About Us", to: "/about" },
    ],
  };

  return (
    <div className="min-h-screen bg-[#f8f5ee] text-[#1c2e22]">
      <Header />
      <main>
        <PageBanner
          bgImage={pageBanner.bgImage}
          eyebrow={pageBanner.eyebrow}
          title={pageBanner.title}
          breadcrumbs={pageBanner.breadcrumbs}
        />
        <AboutUsIntro />
        <ImageCarosel />
        <FeaturesSection />
        <VisitSection />
        <StatsSection />
        <ExperienceSection />
        <OurTeam />
        <ReservationSection />
        <InstagramSection />
      </main>
      <Footer />
      <FloatingCta />
    </div>
  );
};

export default AboutUsPage;
